// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-to-account-menu.dropdown {
  margin-top: -4px;
  margin-bottom: 6px;
  padding: 0px;
  border:none;
  opacity: 1.0;
  display: contents;
}

.add-to-account-menu.dropdown:hover {
  background: transparent;
  opacity: 1.0;
  cursor: pointer;
}

button#add-to-account-menu-toggle:hover{
  background-color: white;
}
`, "",{"version":3,"sources":["webpack://./src/styles/PublicContents.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".add-to-account-menu.dropdown {\n  margin-top: -4px;\n  margin-bottom: 6px;\n  padding: 0px;\n  border:none;\n  opacity: 1.0;\n  display: contents;\n}\n\n.add-to-account-menu.dropdown:hover {\n  background: transparent;\n  opacity: 1.0;\n  cursor: pointer;\n}\n\nbutton#add-to-account-menu-toggle:hover{\n  background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
